import { fireUtagLinkEvent } from "@crystal/analytics";
import "react";
import "../state/reducers.js";
import "../state/actions.js";
import "../state/utils.js";
import "../store/storage/memory-storage.js";
import "mitt";
import "../store/storage/universal-memory-storage.js";
import "@crystal/core";
import "@reduxjs/toolkit";
import "../store/state/host.js";
import "../store/state/modal.js";
import { getTouchpointName } from "../integration/state-getters.js";
import "../api/email-detection.js";
import "@account/configs";
import "@crystal/glass-bridge";
import "@crystal/http";
import "@crystal/recaptcha";
import "../config/source-ids.js";
import "../config/presets.js";
import "../ap2/config.js";
import "../ap2/state.js";
import "./config.js";
import "@crystal/config";
const trackSocialLoginStart = (provider) => {
  const touchPointName = getTouchpointName();
  fireUtagLinkEvent({
    event_category: "LOGIN",
    event_name: `SOCIAL|${provider}|START`,
    login_location: `${touchPointName}`
  });
};
export {
  trackSocialLoginStart
};
//# sourceMappingURL=analytics.js.map
